<template>
  <div>
    <div class="orderSn">
      <p>请及时付款，以便订单尽快处理</p>
      <span>交易号：{{orderid}}</span>
    </div>
    <div class="code_img">
      <div class="code">
        <canvas id="canvas" style="width:175px;height:175px"></canvas>
        <p>微信扫一扫支付</p>
      </div>
      <img src="../assets/images/icon_7.png" />
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
export default {
  data() {
    return {
      // codes: "",
      orderid: "",
    };
  },
  components: {
    QRCode: QRCode
  },
  created(){
    this.orderid = this.$route.query.orderid;
  },
  methods: {
    useqrcode(result) {
      var canvas = document.getElementById("canvas");
      QRCode.toCanvas(canvas, result, function(error) {
        if (error) console.error(error);
        console.log("success!");
      });
    }
  },
  mounted() {
    let result = this.$route.query.result;
    this.useqrcode(result);
  }
};
</script>

<style scoped>
.orderSn{
  width: 1200px;
  height:86px;
  margin: 22px auto 100px;
  padding: 12px 21px 21px;
  background:rgba(245,245,245,1);
}
.orderSn p,
.orderSn span{
  display: block;
  color: #666;
  padding-top: 9px;
}
.orderSn p{
  color: #333;
  font-size: 20px;
  font-weight: bold;
}
.code_img{
  font-size: 0;
  text-align: center;
  padding-bottom: 170px;
}
.code_img .code{
  display: inline-block;
  vertical-align: top;
  padding: 100px 70px 0 0;
}
.code_img .code canvas{
  width: 175px;
  height: 175px;
}
.code_img .code p{
  color: #333;
  font-size: 20px;
  padding-top: 15px;
}
</style>